"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeProductObject = void 0;
const changeProductObject = (products) => {
    const newList = products.map((product) => {
        return {
            brand: product.brand,
            category: product.category,
            description: product.completeDescription,
            discount: product.discount,
            discountPrice: product.discountPrice,
            images: product.images,
            name: product.description,
            price: product.price,
            sku: product.sku,
            subcategory: product.subCategory,
            tags: product.tags || [],
        };
    });
    return newList;
};
exports.changeProductObject = changeProductObject;
